import { StatusBar } from "expo-status-bar";
import { StyleSheet, Text, View, Image, ActivityIndicator } from "react-native";
import CameraScreen from "./screens/CameraScreen";
import { withDecay } from "react-native-reanimated";
import { useEffect, useState } from "react";
import { VisionAPI } from "./api/heroVisionApi";
import AppLoading from "expo-app-loading";

import exampleResponse from "./static/exampleResponse.json";
import * as Font from "expo-font";
import { LoadingScreen } from "./screens/LoadingScreen";
import ResultsScreen from "./screens/ResultsScreen";
import { ThemeProvider } from "./contexts/ThemeContext";

const loadFonts = async () => {
  await Font.loadAsync({
    NinjaTurtles: require("./assets/fonts/NinjaTurtles-AArm.otf"),
    FightingSpirit: require("./assets/fonts/FightingSpiritTbs-pMaK.ttf"),
    SuperBrigade: require("./assets/fonts/SuperBrigadeRotalic-5yaVL.otf"),
    Typhoon: require("./assets/fonts/Typhoon-9MXzZ.otf"),
  });
};

export default function App() {
  const [loading, setLoading] = useState(false);
  const [fontsLoaded, setFontsLoaded] = useState(false);

  const [image, setImage] = useState<string | null>(null);
  const [counters, setCounters] = useState([] as any[]);

  const [matchedHeros, setMatchedHeros] = useState<string[] | null>(null);

  useEffect(() => {
    loadFonts().then(() => setFontsLoaded(true));
  }, []);

  const handlePhotoTaken = (imgUri: string) => {
    setImage(imgUri);
  };

  useEffect(() => {
    if (image) {
      performVision();
    }
  }, [image]);

  const performVision = async () => {
    try {
      setLoading(true);
      if (image) {
        const results = await VisionAPI.create(image);

        // console.log("received results", results);
        //console.log('example response', exampleResponse as any)
        //setMatchedHeros((exampleResponse as any).detected);
        //setCounters((exampleResponse as any).counters)
        setMatchedHeros(results.detected);
        setCounters(results.counters);
      }
    } catch (error) {
      console.log("uh oh", error);
    } finally {
      setLoading(false);
    }
  };

  if (!fontsLoaded) {
    return <AppLoading />;
  }

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <ThemeProvider>
      {loading && <LoadingScreen />}

      {!loading && matchedHeros ? (
        <ResultsScreen
          heros={matchedHeros.map((h) => {
            return { id: h };
          })}
          counters={counters}
          onClear={() => {
            setMatchedHeros(null);
          }}
        />
      ) : (
        <View style={{height: '100%', width: '100%', backgroundColor: 'white'}}>
           <View
          style={{
            width: 300,
            height: 300,
            // borderWidth: 2,
            // borderColor: "blue",
            margin: "auto",
            backgroundColor: "white",
            padding: 3,
          }}
        >
          <CameraScreen
            onClear={() => {}}
            onTakePhoto={(imageUri: string) => {
              handlePhotoTaken(imageUri);
            }}
          />
        </View>
        </View>
       
      )}
    </ThemeProvider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
